import {
  EntityAutocompletePicker,
  type DefaultEntityFilters,
  type EntityFilter,
} from '@backstage/plugin-catalog-react';

// The catalog's own `kind` filter is single-valued and the stock
// EntityKindPicker always has one kind selected, which doesn't suit a docs
// index that should open on every kind. This is a multi-valued filter under
// its own key (`kinds`) so it can't collide with `filters.kind`. It is
// resolved by the catalog backend, so no filterEntity is needed.
export class EntityKindsFilter implements EntityFilter {
  constructor(readonly values: string[]) {}

  getCatalogQuery() {
    return this.values.length > 0 ? { kind: { $in: this.values } } : undefined;
  }

  toQueryValue() {
    return this.values;
  }
}

type TechDocsEntityFilters = DefaultEntityFilters & {
  kinds?: EntityKindsFilter;
  techdocs?: EntityFilter;
};

// Facet values are scoped to the `techdocs` filter (set by TechDocsPicker)
// rather than the default `kind` filter, so the dropdown only offers kinds
// that actually have docs. Must be rendered inside the same
// EntityListProvider as TechDocsPicker.
export const TechDocsKindPicker = () => (
  <EntityAutocompletePicker<TechDocsEntityFilters, 'kinds'>
    label="Kind"
    name="kinds"
    path="kind"
    Filter={EntityKindsFilter}
    filtersForAvailableValues={['techdocs']}
    showCounts
  />
);
